<template>
    <div class="movie-wrapper page-background-color-white ticket-order-info-wrapper">
        <div class="movie-box padding-top-bottom ticket-order-info-top">游客{{index}}信息</div>
        <div class="movie-box">
            <div v-for="(it, ind) in ticket_collector.values" :key="ind">
                <label class="movie-box acea-row row-between-wrapper label-wrapper" v-if="it.Type === 'UserName' && it.ID == 3">
                    {{it.Name}}<input class="input-text" type='text' placeholder="请输入证件上的真实姓名" required v-model.trim="it.value"/>
                </label>
                <label class="movie-box acea-row row-between-wrapper label-wrapper" v-if="it.Type === 'ContactPhone' && it.ID == 11">
                    {{it.Name}}<input class="input-text" type='text' placeholder="请输入手机号" required v-model.trim="it.value"/>
                </label>
                <label class="movie-box acea-row row-between-wrapper label-wrapper" v-if="it.Type === 'IDType' && it.ID == 5">
                    {{it.Name}}<div class="input-text acea-row row-between-wrapper" @click="isShow(true)">
                                <span>{{it.value || "请选择"}}</span>
                                <span :style="{'font-size':'.35rem'}">></span>
                            </div>
                </label>
                <!-- 选择证件类型 -->
                <TicketOrderSelectWindow :arr="arr" :_isShow="openSelect" @checkedOption="checkedOption" @isShow="isShow"></TicketOrderSelectWindow>

                <label class="movie-box acea-row row-between-wrapper label-wrapper" v-if="it.Type === 'IDNumber' && it.ID == 7">
                    {{it.Name}}<input class="input-text" type='text' placeholder="请填写证件号" required v-model.trim="it.value"/>
                </label>
                <label class="movie-box acea-row row-between-wrapper label-wrapper" v-if="it.Type === 'Sex' && it.ID == 6">
                    {{it.Name}}<input class="input-text" type='text' placeholder="1:男 2:女 请输入1或2" required v-model.trim="it.value"/>
                </label>
                <label class="movie-box acea-row row-between-wrapper label-wrapper" v-if="it.Type !== 'Sex' && it.Type !== 'UserName' && it.Type !== 'ContactPhone' && it.Type !== 'IDType' && it.Type !== 'IDNumber'">
                    {{it.Name}}<input class="input-text" type='text' :placeholder="'请填写'+it.Name" required v-model.trim="it.value"/>
                </label>
                <div class="rule-tips page-relative" :class="{'openTrue': isShowRule}" @click="showRule" v-if="it.Type === 'EnglishName' && it.ID == 2">
                    <div class="font-color-red">
                        *英文名格式要求：1、必须用字母填写且与证件保持一致。2、请以姓在前名在后的方式填写，姓和名之间须用“/”隔开，如有中间名则空一格紧随名之后（last/first middle）。 例：Zhang/Sanfeng(张三风)；Green（姓）/Jim（名） Stephanie（中间名）。3、英文名字的长度不可超过26个字符，如名字过长请使用缩写，出行人的姓氏不能缩写，名可以缩写。姓氏中如包括空格请在输入时删除空格。4、英文姓名不可少于2个英文单词。
                    </div>
                    <div v-if="!isShowRule" class="page-absolute page-text-center open">﹀</div>
                    <div v-if="isShowRule" class="page-absolute page-text-center open">︿</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TicketOrderSelectWindow from "@components/TicketOrderSelectWindow.vue";
import attrs, { required, chs_phone, chs_id } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
    name: "TicketAddTouristInfo",
    components: {
        TicketOrderSelectWindow
    },
    props: {
        index: {
            type: Number,
            default: 1
        },
        arr: {
            type: Array,
            default: ()=>[]
        },
        item: {
            type: Object,
            default: ()=>{}
        }
    },
    data: function () {
        return {
            openSelect: false,
            ticket_collector: {},
            isShowRule: false
        }
    },
    watch: {
        item: {
            handler: function (newVal) {
                this.ticket_collector = newVal;
            },
            deep: true,
            immediate: true
        },
        ticket_collector: {
            handler: function (newVal) {
                // console.log(newVal,"tco")
                this.$emit('touristInfo', newVal);
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        showRule: function () {
            this.isShowRule = !this.isShowRule;
        },
        checkedOption: function (value) {
            this.ticket_collector.values && this.ticket_collector.values.forEach(val => {
                if (val.Type === "IDType" && val.ID == 5) {
                    val.value = value.text;
                    val.idType = value.value;
                }
            });
        },
        isShow: function (val) {
            this.openSelect = val;
        }
    }
}
</script>

<style scoped>
.padding-top-bottom {
    padding: .3rem 0 .2rem;
}
.ticket-order-info-wrapper {
    width: 92%;
    margin: .2rem auto 0;
    border-radius: .1rem;
}
.ticket-order-info-top {
    border-bottom: .02rem solid #eee;
    font-size: .34rem;
}
.label-wrapper {
    height: .8rem;
    font-size: .32rem;
}
.input-text {
    height: 100%;
    width: 75%;
}
.rule-tips {
    height: .6rem;
    overflow: hidden;
}
.open {
    width: 100%;
    height: .3rem;
    line-height: .5rem;
    bottom: 0;
    left: 0;
    background: rgba(255,255,255, 0.7)
}
.openTrue {
    height: auto;
}
</style>